import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";
import { GetEmploymentStatusModel } from "@core/model/query-model-employment-status";
import { employmentStatusFormDefault } from "./form.default";
import { EmploymentStatusFormSchema } from "./form.rule";

export const useFormDefaultEmploymentStatus = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetEmploymentStatusModel | undefined) => {
    return !cachedValue
      ? employmentStatusFormDefault
     : ({
        name: cachedValue.name,
        description: cachedValue.description,
      } as EmploymentStatusFormSchema);
  };

  return {
    getDefault,
  };
};
